// Third party librarie
import Compressor from 'compressorjs';

export const imageUploadMixins = {
	data() {
		return {
			imageUrl: '',
			fileBlob: null,
			imageToCrop: '',
			isImageChanged: false,
			ImageTypeList:['image/tiff','image/webp']
		}
	},
	methods: {
		clearFileInput(event) {
			event.target.value = '';
		},
		resetImageFields() {
			this.imageUrl = '';
			this.fileBlob = null;
			this.imageToCrop = '';
			this.isImageChanged = false;
		},
		setImageCrop({image, blob}) {
			this.isImageChanged = true;
			this.imageUrl = image;
			this.fileBlob = blob;
		},
		async validateImage(img) {
			// if File doesn't exist means user cancelled file upload.
			if (!img) {
				return false;
			}
			// get size in binary format
			let size = Math.round(img.size / 1024);
			let errorMessage = '';
			let isValid = true;

			// check File Size if exceeds 5 MB
			if (size > 20480 && isValid) {
				errorMessage = 'File Size must not exceed 20 MB.';
				isValid = false;
			}

			// check if File Type is an Image
			const imageType = this.ImageTypeList.find((element) => element === img.type);
			const imageIsInvalid = !!imageType

			// check if File Type is an Image
			// if ((img.type.includes('image/tiff') || !img.type.includes('image')) && isValid) {
			// 	errorMessage = 'Unsupported File Format.';
			// 	isValid = false;
			// }

			if ((imageIsInvalid || !img.type.includes('image')) && isValid) {
				errorMessage = `${img.name} has unsupported File Format. `;
				isValid = false;
			}

			// check if broken image
			let url = window.URL || window.webkitURL;
			let image = new Image();
			image.src = url.createObjectURL(img);
			const isImageBodyValid  = await this.checkImageBody(image.src)
			if (!isImageBodyValid) {
				errorMessage = `${img.name} contains unsupported image format.`;
				isValid = isImageBodyValid;
			}
			
			if (!isValid) {
				this.showCustomErrorToast('Unable to upload file.', errorMessage);
			}

			// if (!isValid) {
			// 	this.showCustomErrorToast('Unable to upload file', errorMessage);
			// }

			return isValid;
		},
		async onUploadImage(event) {
			const isValid = await this.validateImage(event.target.files[0]);

			// do nothing when user cancels Upload
			if (!isValid) {
				// reset uploader
				this.$refs.imgUploader.value = '';
				return;
			}

			// compress image if more than 2mb
			const file = await this.compressImage(event.target.files[0])

			this.fileBlob = [file];

			// show preview of pet image
			const reader = new FileReader();
			reader.onload = () => {
				this.imageToCrop = reader.result;
				this.$refs.modalFileUpload.show();
			}

			reader.readAsDataURL(file);
		},
		async compressImage(file) {
			let compressedJS = null;
			if (file.size > 20000) {
				await new Promise((resolve, reject) => {
					new Compressor(file, {
						maxWidth: this.maxWidth,
						maxHeight: this.maxHeight,
						quality: this.quality,
						success: resolve,
						error: reject
					});
				}).then(result => {
					compressedJS = new File([result], result.name, { type: result.type });
				}).catch(() => {
					return;
				});
			} else {
				compressedJS = file;
			}

			return compressedJS;
		},
		
		async compressMultipleImages(files) {
			let compressImages = await Promise.all(
				files.map(async file => {
					return await this.compressImage(file);
				}));

			return compressImages;
		},

		validateMultipleImages(images) {
			let validatedImages = [];
			const checker = arr => arr.every(value => value === true);

			if (!images) {
				return false;
			}

			for (const image in images) {
				let valid = this.validateImage(images[image]);
				validatedImages.push(valid);
			}

			let areImagesValid = checker(validatedImages);
			// if (!areImagesValid) {
			// 	this.showCustomErrorToast('Unable to upload files.', errorMessage);
			// }

			return true;
		},
		async checkImageBody(url) {
			if (!url || typeof url !== 'string') return Promise.resolve(false);
			return new Promise((resolve) => {
			  const imgElement = new Image();
			  imgElement.addEventListener('load', () => resolve(true));
			  imgElement.addEventListener('error', () => resolve(false));
			  imgElement.src = url;
			});
		},
		async validateImageWithType(img, imageTypeList) {
			// if File doesn't exist means user cancelled file upload.
			if (!img) {
				return false;
			}

			// get size in binary format
			let size = Math.round(img.size / 1024);
			let errorMessage = '';
			let isValid = true;
			
			// check File Size if exceeds 5 MB
			if (size > 20000 && isValid) {
				errorMessage = 'File Size must not exceed 20 MB.';
				isValid = false;
			} 
			// check if File Type is an Image
			const imageType = imageTypeList.find((element) => element === img.type);
			const imageIsValid = !!imageType
			
			if ((!imageIsValid || !img.type.includes('image')) && isValid) {
				errorMessage = `${img.name} has unsupported File Format. `;
				isValid = false;
			}

			// check if broken image
			let url = window.URL || window.webkitURL;
            let image = new Image();
            image.src = url.createObjectURL(img);
			const isImageBodyValid  = await this.checkImageBody(image.src)
			if (!isImageBodyValid) {
				errorMessage = `${img.name} contains unsupported image format.`;
				isValid = isImageBodyValid;
			}

			if (!isValid) {
				this.showCustomErrorToast('Unable to upload file.', errorMessage);
			}
			
			return isValid;
		},
	}
}